export const TRIGGER_TARGETS = {
  CHILDREN: 'children',
  TOOLTIP: 'tooltip',
} as const;

export const TRIGGER_EVENTS = {
  CLICK: 'click',
  HOVER: 'hover',
} as const;
